import * as toastr from "toastr";
import { IInvoiceSubmissionModel, InvoiceDetails } from "../../Models/ProcessReview/invoiceSubmission";
import * as Services from "../../Services";
import { formatMoney } from "../../Shared/React/constants/moneyFormat";

export abstract class SubmitProcessReviewInvoiceCtrl<TSubmission extends IInvoiceSubmissionModel, TInvoiceDetails extends InvoiceDetails> {
  public invoiceSubmission: TSubmission;
  public igsCustomerNumber: string;
  public currentDate: number;
  public isSubmitted: boolean = false;

  protected abstract processReviewType: string;
  protected invoiceDetails: TInvoiceDetails;

  constructor(
    protected $state: angular.ui.IStateService,
    protected documentApiClient: Services.DocumentApiClient.IDocumentApiClient,
    protected processReviewInvoiceApiClient: Services.ProcessReviewInvoiceApiClient.IProcessReviewInvoiceApiClient,
  ) {
    this.igsCustomerNumber = this.$state.params.igsCustomerNumber;
    this.currentDate = Date.now();
    
    this.invoiceSubmission = this.getInvoiceSubmission();
    this.getInvoiceDetails();
  }

  public submit() {
    this.isSubmitted = true;
    this.processReviewInvoiceApiClient.submitProcessReviewInvoice(this.invoiceSubmission, this.processReviewType).then((response: any) => {
      if (response.data.success) {
        this.onSubmitSuccess();
        this.navigateToCustomerPage();
      } else {
        this.isSubmitted = false;
        const errorString = response.data.errors.reduce((strOne, strTwo) => strOne + strTwo + "\r\n");
        toastr.error(errorString);
      }
    }).catch((error: any) => {
      this.isSubmitted = false;
      this.onSubmitError();
    });
  }

  public cancel() {
    this.navigateToCustomerPage();
  }

  public navigateToCustomerPage() {
    this.$state.go(
      "main.customerv2",
      {
        igsCustomerNumber: this.invoiceSubmission.igsCustomerNumber,
      });
  }

  public validSubmission() {
    return this.invoiceSubmission
      && this.documentValid()
      && this.invoiceNumberValid()
      && this.validate();
  }

  public invoiceNumberValid() {
    var invoiceNumberRequired = this.invoiceDetails.invoiceAmount != 0 || this.invoiceSubmission.document.file != null;

    if(invoiceNumberRequired && !this.invoiceSubmission.invoiceNumber) return false;

    return !(this.invoiceSubmission.invoiceNumber
      && this.invoiceSubmission.invoiceNumber.length > 0
      && (this.invoiceSubmission.invoiceNumber === this.invoiceDetails.invoiceAmount.toString()
        || this.invoiceSubmission.invoiceNumber === formatMoney(this.invoiceDetails.invoiceAmount.toString())
        || "$" + this.invoiceSubmission.invoiceNumber === formatMoney(this.invoiceDetails.invoiceAmount.toString())));
  }

  protected abstract getInvoiceDetails(): void;
  protected abstract validate(): boolean;
  protected abstract getInvoiceSubmission(): TSubmission;
  protected abstract onSubmitError(): void;
  protected abstract onSubmitSuccess(): void;

  private documentValid() {
    if(this.invoiceDetails.isAutoGeneratedInvoice || this.invoiceDetails.isPartnerInvoiceAutoGenerated) return true;

    if (this.invoiceDetails.invoiceAmount !== 0) {
      return this.invoiceSubmission.document.file && this.invoiceSubmission.document.file.name && this.invoiceSubmission.invoiceNumber;
    } else if (this.invoiceSubmission.document.file && this.invoiceSubmission.document.file.name) {
      return this.invoiceSubmission && this.invoiceSubmission.invoiceNumber && this.invoiceSubmission.invoiceNumber.length > 0;
    } else if (this.invoiceSubmission && this.invoiceSubmission.invoiceNumber && this.invoiceSubmission.invoiceNumber.length > 0) {
      return this.invoiceSubmission.document.file && this.invoiceSubmission.document.file.name;
    }
    return true;
  }


}
